import { createRouter, createWebHistory } from 'vue-router';
import AdminLayout from '@/components/AdminLayout.vue';
import UserLayout from '@/components/UserLayout.vue';
import LoginPage from '@/components/LoginComponent.vue';
function isAuthenticated() {
  return sessionStorage.getItem('authToken') !== null; 
}
const routes = [
  {
    path: '/admin',
    component: isAuthenticated() ? AdminLayout : LoginPage, // Show login if not authenticated
    beforeEnter: (to, from, next) => {
      if (!isAuthenticated()) {
        next(); // Show login page
      } else {
        next('/admin/dashboard'); // Redirect authenticated users to dashboard
      }
    },
  },
  {
    path: '/admin/dashboard',
    component: AdminLayout, // AdminLayout as the parent component
    meta: { requiresAuth: true }, // Protect admin pages
    children: [
      {
        path: 'Add_Tiles_Information',
        name: 'Add_Tiles_Information',
        component: () => import('@/components/TilesContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'TilesEditInformation',
        name: 'TilesEditInformation',
        component: () => import('@/components/TilesEditAndDelete.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'Add_Washbasin_Information',
        name: 'Add_Washbasin_Information',
        component: () => import('@/components/WashbasinContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'WashbasinEditInformation',
        name: 'WashbasinEditInformation',
        component: () => import('@/components/WashbasinEditAndDelete.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'Add_Toilet_Seat_Information',
        name: 'Add_Toilet_Seat_Information',
        component: () => import('@/components/ToiletSeatContent.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'ToiletSeatEditDelete',
        name: 'ToiletSeatEditDelete',
        component: () => import('@/components/ToiletSeatEditDelete.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'Add_Toilet_Pan_Information',
        name: 'Add_Toilet_Pan_Information',
        component: () => import('@/components/ToiletpanContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'ToiletPanEditDelete',
        name: 'ToiletPanEditDelete',
        component: () => import('@/components/ToiletPanEditDelete.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'Add_Toilet_Urinal_Set_Information',
        name: 'Add_Toilet_Urinal_Set_Information',
        component: () => import('@/components/ToiletUrinalSetContent.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'ToiletUrinalSetEditDelete',
        name: 'ToiletUrinalSetEditDelete',
        component: () => import('@/components/ToiletUrinalSetEditDelete.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'Add_Bathtubs_Information',
        name: 'Add_Bathtubs_Information',
        component: () => import('@/components/BathTubContent.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'BathtubsEditDelete',
        name: 'BathtubsEditDelete',
        component: () => import('@/components/BathtubsEditDelete.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'Add_RestRoom_accessories_Information',
        name: 'Add_RestRoom_accessories_Information',
        component: () => import('@/components/FaucetContent.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'RestRoomAccessoriesEditDelete',
        name: 'RestRoomAccessoriesEditDelete',
        component: () => import('@/components/RestRoomAccessoriesEditDelete.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'Add_Granites_Information',
        name: 'Add_Granites_Information',
        component: () => import('@/components/granitesContent.vue'),
        meta: { requiresAuth: true }, // Lazy-loaded component
      },
      {
        path: 'GraniteStoneEditDelete',
        name: 'GraniteStoneEditDelete',
        component: () => import('@/components/GraniteStoneEditDelete.vue'), 
        meta: { requiresAuth: true },
      },
      {
        path: 'Add_Kadapa_Information',
        name: 'Add_Kadapa_Information',
        component: () => import('@/components/KadapaStonesContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'KadapaStoneEditDelete',
        name: 'KadapaStoneEditDelete',
        component: () => import('@/components/KadapaStoneEditDelete.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'Add_Kitchen_Sink_Information',
        name: 'Add_Kitchen_Sink_Information',
        component: () => import('@/components/kitchenSinkContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'KitchenSinkEditDelete',
        name: 'KitchenSinkEditDelete',
        component: () => import('@/components/KitchenSinkEditDelete.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'Add_Kitchen_Sink_Accesories_Information',
        name: 'Add_Kitchen_Sink_Accesories_Information',
        component: () => import('@/components/kitchenSinkAccesoriesContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'KitchenSinkAccessoriesEditDelete',
        name: 'KitchenSinkAccessoriesEditDelete',
        component: () => import('@/components/KitchenSinkAccessoriesEditDelete.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'Add_Flush_Tank_Information',
        name: 'Add_Flush_Tank_Information',
        component: () => import('@/components/flush-tankContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'FlushTankEditDelete',
        name: 'FlushTankEditDelete',
        component: () => import('@/components/FlushTankEditDelete.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'Add_Flush_Tank_accessories_Information',
        name: 'Add_Flush_Tank_accessories_Information',
        component: () => import('@/components/FlushTankAccesoriesContent.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      {
        path: 'FlushTankAccesoriesEditDelete',
        name: 'FlushTankAccesoriesEditDelete',
        component: () => import('@/components/FlushTankAccesoriesEditDelete.vue'), // Lazy-loaded component
        meta: { requiresAuth: true },
      },
      // Add other child routes as needed
    ],
  },
  {
    path: '/',
    component: UserLayout, // UserLayout as the parent component
    children: [
      {
        path: '', // Default child route for '/'
        name: 'Homedefault',
        component: () => import('@/components/homecomponent/HomePage.vue'), // HomePage component
        meta: {
      title: 'Ganesh Tiles - Best Tiles Showroom in Usilampatti',
      metaTags: [
        {
          name: 'description',
          content: 'Ganesh Tiles offers high-quality floor and wall tiles, sanitaryware, and more in Usilampatti. Best prices and latest designs.'
        },
        {
          name: 'keywords',
          content: 'Ganesh Tiles, Tiles showroom Usilampatti, Floor tiles, Wall tiles, Sanitaryware'
        },
        {
          property: 'og:title',
          content: 'Ganesh Tiles - Premium Tiles Showroom in Usilampatti'
        },
        {
          property: 'og:description',
          content: 'Explore a wide range of tiles and sanitaryware at Ganesh Tiles. Visit our Usilampatti showroom today.'
        },
        {
          property: 'og:url',
          content: 'https://ganeshtiles.in/'
        }
      ]
    }
  
      },
      {
        path: 'home', // Ensure this is absolute
        name: 'home',
        component: () => import('@/components/homecomponent/HomePage.vue'),
    },
    {
      path: 'tiles/category/:category_id/:category_name',
      name: 'TilesCategory',
      component: () => import('@/components/TilesComponent/CategoriesComponent.vue'),
      props: (route) => ({
        categoryId: route.params.category_id,
        categoryName: route.params.category_name,
      }),
    },
    {
      path: 'tiles/category/:category_id/:category_name/product_details',
      name: 'TilesCategoryProductDetails', // Improved naming
      component: () => import('@/components/TilesComponent/CategoriesProductDetailsComponent.vue'),
      props: (route) => ({
        categoryId: route.params.category_id, // Ensure it's a number
        categoryName: route.params.category_name,
      }),
    },
    {
      path: 'tiles/size/:size_id/:size_name',
      name: 'TilesSize',
      component: () => import('@/components/TilesComponent/SizeComponent.vue'),
      props: (route) => ({
        SizeId: route.params.size_id,
        SizeName: route.params.size_name,
      }),
    },
    {
      path: 'tiles/size/:size_id/:size_name/product_details',
      name: 'TilesSizeProductDetails', // Improved naming
      component: () => import('@/components/TilesComponent/TilesSizeProductDetailsComponent.vue'),
      props: (route) => ({
        SizeId: route.params.size_id, // Ensure it's a number
        SizeName: route.params.size_name,
      }),
    },
    {
      path: 'tiles/WhereTouse/:where_to_use_id/:where_to_use_name',
      name: 'TilesWhereTouse',
      component: () => import('@/components/TilesComponent/WhereToUseComponent.vue'),
      props: (route) => ({
        WhereTouseId: route.params.where_to_use_id,
        WhereTouseName: route.params.where_to_use_name,
      }),
    },
    {
      path: 'tiles/WhereToUse/:WhereToUse_id/:WhereToUse_name/product_details',
      name: 'TilesWhereToUseProductDetails', // Improved naming
      component: () => import('@/components/TilesComponent/TilesWhereTouseProductDetailsComponent.vue'),
      props: (route) => ({
        WhereToUseId: route.params.WhereToUse_id, // Ensure it's a number
        WhereToUseName: route.params.WhereToUse_name,
      }),
    },
    {
      path: 'tiles/material/:material_id/:material_name',
      name: 'Tilesmaterial',
      component: () => import('@/components/TilesComponent/MaterialComponent.vue'),
      props: (route) => ({
        MaterialId: route.params.material_id,
        MaterialName: route.params.material_name,
      }),
    },
    {
      path: 'tiles/Material/:Material_id/:Material_name/product_details',
      name: 'TilesMaterialProductDetails', // Improved naming
      component: () => import('@/components/TilesComponent/TilesMaterialProductDetailsComponent.vue'),
      props: (route) => ({
        MaterialId: route.params.Material_id, // Ensure it's a number
        MaterialName: route.params.Material_name,
      }),
    },
    {
      path: 'tiles/SurfaceFinish/:surface_finish_id/:surface_finish_name',
      name: 'TilesSurfaceFinish',
      component: () => import('@/components/TilesComponent/SurfaceFinishComponet.vue'),
      props: (route) => ({
        SurfaceFinishId: route.params.surface_finish_id,
        SurfaceFinishName: route.params.surface_finish_name,
      }),
    },
    {
      path: 'tiles/SurfaceFinish/:surfacefinish_id/:surfacefinish_name/product_details',
      name: 'TilesSurfacefinishProductDetails', // Improved naming
      component: () => import('@/components/TilesComponent/TilesSurfaceFinishProductDetailsComponent.vue'),
      props: (route) => ({
        SurfaceFinishId: route.params.surfacefinish_id, // Ensure it's a number
        SurfaceFinishName: route.params.surfacefinish_name,
      }),
    },
    {
      path: 'tiles/color/:color_id/:color_name',
      name: 'Tilescolor',
      component: () => import('@/components/TilesComponent/ColorComponent.vue'),
      props: (route) => ({
        ColorId: route.params.color_id,
        ColorName: route.params.color_name,
      }),
    },
    {
      path: 'tiles/Color/:Color_id/:Color_name/product_details',
      name: 'TilesColorProductDetails', // Improved naming
      component: () => import('@/components/TilesComponent/TilesColorProductDetailsComponent.vue'),
      props: (route) => ({
        ColorId: route.params.Color_id, // Ensure it's a number
        ColorName: route.params.Color_name,
      }),
    },
    {
      path: 'sanitarware', // Ensure this is absolute
      name: 'sanitarware',
      component: () => import('@/components/SanitaryWareComponent/SanitaryWareComponenet.vue'),
  },
  {
    path: 'sanitarware/:general_category/:product_id/:product_name/product_details',
    name: 'SanitarywareProductDetails', // Improved naming
    component: () => import('@/components/SanitaryWareComponent/SanitaryWareProductDetailsComponenet.vue'),
    props: (route) => ({
      productId: route.params.product_id, // Ensure it's a number
      category: route.params.general_category,
      productname:route.params.product_name
    }),
  },
  {
    path: 'faucet', // Ensure this is absolute
    name: 'faucet',
    component: () => import('@/components/FaucetComponent/FaucetUserViewComponenet.vue'),
},
{
  path: 'faucet/:general_category/:product_id/:product_name/product_details',
  name: 'FaucetProductDetails', // Improved naming
  component: () => import('@/components/FaucetComponent/FaucetProductDetailsComponenet.vue'),
  props: (route) => ({
    productId: route.params.product_id, // Ensure it's a number
    category: route.params.general_category,
    productname:route.params.product_name
  }),
},
{
  path: 'Granites', // Ensure this is absolute
  name: 'Granites',
  component: () => import('@/components/GranitesComponent/GranitesAndKadapaUserViewComponent.vue'),
},
{
  path: 'Granites/:general_category/:product_id/:product_name/product_details',
  name: 'GraniteStonesProductDetails', // Improved naming
  component: () => import('@/components/GranitesComponent/GranitesProductDetailsComponenet.vue'),
  props: (route) => ({
    productId: route.params.product_id, // Ensure it's a number
    category: route.params.general_category,
    productname:route.params.product_name
  }),
},
{
  path: 'kitchenSink', // Ensure this is absolute
  name: 'kitchenSink',
  component: () => import('@/components/KitchenComponent/KitchenSinkUserViewComponenet.vue'),
},
{
  path: 'kitchenSink/:general_category/:product_id/:product_name/product_details',
  name: 'KitchenSinkProductDetails', // Improved naming
  component: () => import('@/components/KitchenComponent/KitchenSinkProductDetailsComponenet.vue'),
  props: (route) => ({
    productId: route.params.product_id, // Ensure it's a number
    category: route.params.general_category,
    productname:route.params.product_name
  }),
},
{
  path: 'FlushTank', // Ensure this is absolute
  name: 'FlushTank',
  component: () => import('@/components/FlushTankComponent/FlushTankUserViewComponent.vue'),
},
{
  path: 'FlushTank/:general_category/:product_id/:product_name/product_details',
  name: 'FlushTankProductDetails', // Improved naming
  component: () => import('@/components/FlushTankComponent/FlushTankProductDetailsComponenet.vue'),
  props: (route) => ({
    productId: route.params.product_id, // Ensure it's a number
    category: route.params.general_category,
    productname:route.params.product_name
  }),
},

     
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
      next('/admin'); // Force login
  } else {
      next();
  }
});
router.afterEach((to) => {
  // Set document title
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // Remove any stale meta tags
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).forEach(el => el.remove());

  // Add new meta tags
  if (to.meta.metaTags) {
    to.meta.metaTags.forEach(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute('data-vue-router-controlled', ''); // Mark for removal on next route change
      document.head.appendChild(tag);
    });
  }
});


export default router;
